<template>
  <div class="advisePage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div class="publicityBox" v-if="!showNonePage">
      <ul class="itemBox" v-if="this.listData.length > 0">
        <li v-for="item in listData" :key="item.id" class="itemList">
          <div class="itemMain">
            <span class="isReply">{{
              item.isReply ? "已回复" : "未回复"
            }}</span>
            <span
              class="isUnfold"
              v-if="item.replyContent != ''"
              @click="change(item)"
              >{{ item.showMain ? "收起" : "展开" }}</span
            >

            <p class="suggestContent">{{ item.suggestContent }}</p>
            <p class="replayContent" v-if="item.showMain">
              {{ item.replyContent }}
            </p>
            <p>建议时间:{{ item.createTime }}</p>
          </div>
        </li>
      </ul>
      <div class="nonePage" v-if="this.listData.length < 1">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
      <span class="addBtn" @click="addAdvise"><van-icon name="plus" /></span>
    </div>
    <van-popup
      v-model="popShow"
      round
      position="bottom"
      closeable
      close-icon="close"
      @click-close-icon="cancel"
      :style="{ height: '80%' }"
    >
      <div class="addMain">
        <van-cell-group>
          <van-field
            v-model="formData.realName"
            required
            label="建议人姓名:"
            placeholder="请输入"
          />
          <van-field
            v-model="formData.phone"
            required
            label="联系方式:"
            placeholder="请输入"
          />
          <van-field
            v-model="formData.suggestContent"
            required
            label="建议内容:"
            placeholder="请输入"
            rows="5"
            autosize
            type="textarea"
          />
        </van-cell-group>

        <div class="btnInfo">
          <van-button type="info" round @click="save">保存</van-button>
          <van-button type="danger" round @click="cancel">取消</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "commonPublicity",
  data() {
    return {
      showNonePage: true,
      nonePng: nonePng, //默认图片
      baseUrl: process.env.BASE_URL,
      gridPoint: "", //链接传递的内点
      foestId: "",
      listData: [],
      clientType: "", //手机类型
      popShow: false,
      formData: {
        gridObjid: "",
        phone: "",
        realName: "",
        regionCode: "",
        replyContent: "",
        suggestContent: "",
      },
      saveType: true,
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();

    this.$nextTick(function () {
      if (this.dataInfo.objid && this.dataInfo.type) {
        this.formData.gridObjid = this.dataInfo.objid;
        this.formData.regionCode = this.dataInfo.zqCode;
        this.initDutyPage();
      }
    });
  },
  methods: {
    initDutyPage() {
      //群众列表
      let _this = this,
        params = {};
      if (this.dataInfo.areaType == "zrq") {
        params.gridObjid = _this.formData.gridObjid;
      } else {
        params.regionCode = _this.dataInfo.zqCode;
      }
      _this.$api.pubZrq
        .suggestList(params)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.showNonePage = false;
            if (res.data[0]) {
              res.data.forEach((item) => {
                item.showMain = false;
              });
            }

            _this.listData = res.data;
          } else {
            _this.listData = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    change(item) {
      console.log(item, "item");
      item.showMain = !item.showMain;
    },
    addAdvise() {
      this.popShow = true;
    },
    save() {
      let _this = this;
      if (_this.dataInfo.areaType == "zq") {
        _this.formData.gridObjid = null;
      }
      if (
        this.formData.realName &&
        this.formData.phone &&
        this.formData.suggestContent
      ) {
        _this.$api.pubZrq.suggestSave(this.formData).then((res) => {
          if (res.code == "1") {
            _this.$toast("已提交后台审核!");
            this.popShow = false;
            this.formData.realName = "";
            this.formData.phone = "";
            this.formData.suggestContent = "";
          } else {
            _this.$toast(res.msg);
          }
        });
      } else {
        _this.$toast("带星号为必填不能为空");
      }
    },
    cancel() {
      this.popShow = false;
      this.formData.realName = "";
      this.formData.phone = "";
      this.formData.suggestContent = "";
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        if (this.dataInfo.objid && this.dataInfo.type) {
          this.initDutyPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
.advisePage {
  width: 100%;
  height: 100%;
  position: relative;

  .publicityBox {
    width: 100%;
    height: 100%;
    // padding: 8px 16px 50px;
    overflow-y: hidden;
    background-color: #f6f6f6;
    position: relative;
    .addBtn {
      display: inline-block;
      z-index: 99;
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      background-color: #4bc08a;
      bottom: 30px;
      right: 15px;
      .van-icon {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        line-height: 40px;
      }
    }
    .itemBox {
      width: 100%;
      height: 100%;
      padding: 8px 16px 20px;
      overflow-y: scroll;
      .itemList {
        width: 100%;
        margin: 10px 0;
        position: relative;
        .itemMain {
          width: 100%;
          background-color: #fff;
          border-radius: 8px;
          padding: 8px 8px;
          position: relative;
          .isReply {
            display: inline-block;
            padding: 5px 8px;
            color: #333;
            background-color: rgba(240, 239, 239, 1);
            position: absolute;
            top: 13px;
            left: 5px;
            border-radius: 5px;
          }
          .isUnfold {
            display: inline-block;
            padding: 5px 12px;
            color: #333;
            background-color: rgba(240, 239, 239, 1);
            position: absolute;
            top: 13px;
            right: 5px;
            border-radius: 5px;
          }
          p {
            margin: 5px 0 10px 60px;
            font-size: 12px;
            color: #666;
          }
          p.suggestContent {
            width: 65%;
            font-size: 16px;
            color: #333;
          }
          p.replayContent {
            margin-left: 60px;
            min-height: 60px;
            font-size: 14px;
            background-color: rgba(240, 239, 239, 0.6);
            color: #333;
            padding: 5px 5px;
          }
        }
      }
    }

    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .addMain {
    width: 100%;
    height: 100%;
    // padding-top: 60px;
    position: relative;
    padding: 60px 16px 0 16px;
    .btnInfo {
      width: calc(100% - 32px);
      position: absolute;
      bottom: 10px;
      .van-button {
        width: 40%;
      }
      .van-button:first-child {
        margin-right: 20%;
      }
    }
  }
}
</style>